/**
 * WISHLIST EXPORT
 * 
 * module de gestion de l'export d'une' wishlist
 * via une popin dans
 * la partie PRO de l'espace mon compte
 */
import $ from "jquery";
const utils = require('../utils').default;
import { services } from "../../../../helpers/service";
import { dialog } from "../../../../components/dialog";
const WLExport = (() => {
    const DOM_EXPORT = 'popin-wishlist-export';
    const DOM_EXPORT_SHOW = `[data-js-dialog-open="${DOM_EXPORT}"]`;
    const DOM_EXPORT_POPIN = `[data-js-dialog-id="${DOM_EXPORT}"]`;
    const DOM_EXPORT_SUBMIT = `${DOM_EXPORT_POPIN} .js-wishlist-export`;
    const DOM_EXPORT_ERROR = `${DOM_EXPORT_POPIN} .js-form-error`;

    const DOM_EXPORT_PART = 'popin-wishlist-export-part';
    const DOM_EXPORT_PART_SHOW = `[data-js-dialog-open="${DOM_EXPORT_PART}"`;
    const DOM_EXPORT_PART_POPIN = `[data-js-dialog-id="${DOM_EXPORT_PART}"]`;
    const DOM_EXPORT_PART_SUBMIT = `${DOM_EXPORT_PART_POPIN} .js-wishlist-export`;

    const SUCCESS_LIST_EXPORT = 'Votre fichier à bien été exporté.';
    const ERROR_LIST_EXPORT = 'L\'exportation a échoué.';

    /**
     * POPIN OPEN (func)
     * 
     * Ouverture de la popin creation d'adresse
     */
    const popinOpen = (event) => {
        updateTemplates(event);
        $(DOM_EXPORT_SUBMIT).off().on('click', exportList);
        $(DOM_EXPORT_PART_SUBMIT).off().on('click', exportList);
    };
    /**
     * ON EXPORT SERVICE DONE
     * 
     * téléchargement du fichier après le succes
     * du service d'export
     * @param {object} result 
     */
    var onExportServiceDone = function(result) {
        if (result.datas.file) {
            location.href = result.datas.file;
        } else {
            utils.download(result.datas.filename, result.datas.content)
        }
        utils.dispatchCustomEvent('LOADER');
    };
    /**
     * EXPORT LIST
     * 
     * export de la liste, génération
     * du fichier via service
     * @param {event} event 
     * @returns 
     */
    const exportList = (event) => {
        event.preventDefault();
        let $link = $(event.currentTarget);
        let listId = $link.data('wishlist-id');
        let type = utils.getContext();
        let name = $link.data('wishlist-name');
        let quantity = $link.data('wishlist-quantity');
        let total = $link.data('wishlist-total');
        let format = $link.data('format');
        let xhrData = {
            id: listId,
            format,
            content: window.WL.getWishlistSerialized(name, false),
            name,
            reduction: window.WL.getWishlistReduction(name),
            e: type
        };
        
        dialog.close();
        utils.dispatchCustomEvent('LOADER');
        utils.dispatchCustomEvent('NOTIFICATION_DEFAULT', {content: SUCCESS_LIST_EXPORT, type: 'success'});
        utils.dispatchCustomEvent('TRACKERS_WISHLIST_EXPORT', {format, quantity, total});
        return services.use('wishlistexport', xhrData, false)
            .then(onExportServiceDone)
            .catch(
                () => {
                    utils.dispatchCustomEvent('LOADER');
                    utils.dispatchCustomEvent('TEMPLATE_ERROR', {error:ERROR_LIST_EXPORT});
                }
            );
    };
    /**
     * UPDATE TEMPLATE (func)
     * 
     * Mise à jour du template de la popin 
     * de suppression d'adresse
     */
    const updateTemplates = (event) => {
        let data = {
            name: $(event.currentTarget).data('wishlist-name'),
            id: $(event.currentTarget).data('wishlist-id'),
            quantity: $(event.currentTarget).data('wishlist-quantity'),
            total: $(event.currentTarget).data('wishlist-total'),
        };
        const popin = utils.getContext() === 'part' ? DOM_EXPORT_PART : DOM_EXPORT;
        utils.dispatchCustomEvent('TEMPLATE_POPIN_UPDATE', {popinTargetID: popin, data});
        if (!window.WL.getWishlistList(data.name).length) {
            $(DOM_EXPORT_SUBMIT).attr('disabled', true);
            $(DOM_EXPORT_ERROR).attr('aria-hidden', false);
        } else {
            $(DOM_EXPORT_SUBMIT).attr('disabled', false);
            $(DOM_EXPORT_ERROR).attr('aria-hidden', true);
        }
    };
    const exportButtonInit = () => {
        if ($(DOM_EXPORT_PART_SHOW).length === 0) return;
        const name = window.WL.getWishlistName();
        const id = window.WL.getCurrentWishlist();
        const count = WL.getProductsQuantityTotal().toString();
        const total = window.WL.getWishlistGrandTotal() ? utils.getFormatedPrice(window.WL.getWishlistGrandTotal()) : '-';
        $(DOM_EXPORT_PART_SHOW).attr('data-wishlist-id', id);
        $(DOM_EXPORT_PART_SHOW).attr('data-wishlist-name', name);
        $(DOM_EXPORT_PART_SHOW).attr('data-wishlist-quantity', count);
        $(DOM_EXPORT_PART_SHOW).attr('data-wishlist-total', total);
    }
    /**
     * INIT (func)
     */
    const init = () => {
        utils.debug('WL EXPORT', 'initialisation');  
        exportButtonInit();
        $(DOM_EXPORT_SHOW).off().on('click', popinOpen);
        $(DOM_EXPORT_PART_SHOW).off().on('click', popinOpen);
    }
    return {
        exportButtonInit,
        init
    }
})();
export default WLExport;